export const SET_THEME = 'SET_THEME';

/** @typedef {'day' | 'night'} ThemeMode */

/**
 * Write the theme onto <html> so the CSS custom properties in index.css swap.
 *
 * Done here rather than in a component so the attribute is set before the first
 * paint on rehydrate, which avoids a flash of the day theme for night users.
 *
 * @param {ThemeMode} mode
 */
export const applyTheme = (mode) => {
  if (typeof document === 'undefined') return;

  if (mode === 'night') {
    document.documentElement.setAttribute('data-theme', 'night');
  }
  else {
    document.documentElement.removeAttribute('data-theme');
  }
};

/**
 * @param {ThemeMode} mode
 */
export const setTheme = (mode) => {
  applyTheme(mode);
  return {
    type: SET_THEME,
    mode
  };
};

/**
 * @param {ThemeMode} current
 */
export const toggleTheme = (current) => {
  return setTheme(current === 'night' ? 'day' : 'night');
};
